export default __webpack_public_path__ + "static/media/avatar.2e12a266.svg";